import DOMPurify from 'dompurify';

/**
 * Elements that carry no prose meaning but can act as script or navigation sinks.
 * Dropped on top of the HTML profile's own allowlist.
 */
const FORBID_TAGS = ['button', 'form', 'input', 'select', 'style', 'textarea'];

/**
 * Sanitize an untrusted HTML string before rendering it.
 *
 * Restricts the markup to DOMPurify's HTML profile — SVG and MathML are excluded,
 * as are `script` and embedding elements such as `iframe` — and additionally drops
 * the interactive elements above. Event-handler attributes are removed, and any
 * `href`/`src`/`action` whose scheme is not a safe one (`http`, `https`, `mailto`,
 * `tel`, …) is stripped, so `javascript:` URLs never reach the DOM.
 *
 * Inline formatting used for prose and search highlighting (`a`, `p`, `em`,
 * `strong`, lists, tables, `img`) survives untouched.
 *
 * @param html - Untrusted HTML, typically returned by an external API
 * @returns The sanitized HTML string, safe to hand to an HTML-to-React parser
 */
export default function sanitizeHtml(html: string): string {
    return DOMPurify.sanitize(html, {
        USE_PROFILES: { html: true },
        FORBID_TAGS,
    });
}
